import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import TableHeadTdOrder from 'components/others/TableHeadTdOrder';
import SpinnerBlock from 'components/others/SpinnerBlock';
import WarrantyTableBody from './WarrantyTableBody';
import type { WarrantyTableProps } from './types';

const WarrantyTable = (props: WarrantyTableProps) => {
    const { t } = useTranslation('Warranties');
    const { visible = {}, mini, hideActions, onSort, order, desc } = props;
    const columns = [
        ['prodName', 'name'],
        ...(!mini && visible.category ? [['categoryName', 'category']] : []),
        ...(!mini && visible.vendor ? [['vendorName', 'vendor']] : []),
        ...(!mini && visible.id ? [['productId', 'id']] : []),
        ...(!mini && visible.article ? [['prodArticle', 'article']] : []),
        ['serialNumber', 'serialNumber'],
        ['purchasedAt', 'purchasedAt'],
        ['warrantyUntil', 'warrantyUntil'],
        ...(!mini ? [['objectName', 'object']] : []),
        ...(!mini && visible.price ? [['', 'price']] : []),
    ];
    const tableMinWidth =
        (hideActions ? 800 : 870) +
        (mini ? 0 : 150) +
        (!mini && visible.category ? 180 : 0) +
        (!mini && visible.vendor ? 180 : 0) +
        (!mini && visible.id ? 70 : 0) +
        (!mini && visible.article ? 150 : 0) +
        (!mini && visible.price ? 120 : 0) +
        (props.onSelect ? 40 : 0);
    const headClasses: Record<string, string> = {
        name: 'head-name',
        category: 'head-vendor',
        vendor: 'head-vendor',
        id: 'head-id',
        article: 'head-article',
        serialNumber: 'head-serial-number',
        purchasedAt: 'head-date',
        warrantyUntil: 'head-date',
        object: 'head-warehouse',
        price: 'head-price',
    };
    return (
        <div className="position-relative">
            <SpinnerBlock onlyBlur={true} show={Boolean(props.loading)} />
            <div className="crm-table-wrap">
                <Table
                    className="ProductTable WarrantyTable table-hover"
                    style={{ minWidth: tableMinWidth }}
                >
                    <thead>
                        <tr className="bg-light">
                            {props.onSelect && <td className="head-check" />}
                            {columns.map(([field, label]) => (
                                <td key={label} className={headClasses[label]}>
                                    {onSort && field ? (
                                        <TableHeadTdOrder
                                            title={t(`fields.${label}`)}
                                            fieldName={field}
                                            value={order}
                                            desc={desc}
                                            onClick={(fieldName: string) => onSort(fieldName)}
                                        />
                                    ) : (
                                        t(`fields.${label}`)
                                    )}
                                </td>
                            ))}
                            {!hideActions && <td className="head-action">{t('fields.actions')}</td>}
                        </tr>
                    </thead>
                    <WarrantyTableBody {...props} />
                </Table>
            </div>
        </div>
    );
};

export default WarrantyTable;
